module.exports = "<div class=\"ui-card padding-md\">\r\n  <div class=\"kd-item\">\r\n    <colaborador-code id-proyecto=\"::$ctrl.data.id_empresa\" id-colaborador=\"::$ctrl.data.id_empleado\"></colaborador-code>\r\n    <div class=\"flex nobreak\">\r\n      {{::$ctrl.data.empleado}}\r\n    </div>\r\n    <div class=\"--text-small\">Carga social</div>\r\n    <div class=\"--text-bold\" style=\"width:60px\">\r\n      {{::$ctrl.data.config.carga_social | currency}}\r\n    </div>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/calculo/calcular/resultados/noremunerado/template.html
// module id = 1109
// module chunks = 0